window.slides = document.querySelector('.slides');
window.slideCount = document.querySelectorAll('.slide');
window.prevButton = document.querySelector('.prev');
window.nextButton = document.querySelector('.next');

// slide function
window.currentIndex = 0;

const showSlide = (index) => {
    window.slideCount.forEach((slide, i) => {
        slide.classList.toggle('hidden', i !== index);
    });
}

const nextSlide = () => {
    window.currentIndex = (window.currentIndex === slideCount.length - 1) ? 0 : window.currentIndex + 1;
    showSlide(window.currentIndex);
}

prevButton?.addEventListener('click', () => {
    window.currentIndex = (window.currentIndex === 0) ? slideCount.length - 1 : window.currentIndex - 1;
    showSlide(window.currentIndex);
});

nextButton?.addEventListener('click', () => {
    nextSlide();
});

// Automatically change slides every 5 seconds
// setInterval(nextSlide, 5000);

showSlide(window.currentIndex);